import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { PostagemVendaPendentePagamento } from "../interfaces/PostagemVendaPendentePagamento";

export const buscarPostagensVendaPendentesPagamentoService = async () => {
  const token = validateToken();

  if (!token) {
    return null;
  }

  const url = `${Globais.DOMINIOBACK}/postagens/venda/pendentes-pagamento`;

  try {
    const response = await axios.get<PostagemVendaPendentePagamento[]>(url, {
      headers: { Authorization: token.AuthStr },
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
